import { getSpreadInPoints } from "@/utils/symbols";

type TranslateFn = (key: string) => string;

interface SpreadDisplayValues {
    spreadInPoints: number;
    spreadInPointsDisplayValue: string;
    spreadInPips: number;
    spreadInPipsDisplayValue: string;
}

export function getSpreadDisplayValues(
    bid: number,
    ask: number,
    digits: number,
    t: TranslateFn
): SpreadDisplayValues {
    const points = getSpreadInPoints(ask, bid, digits);
    const pips = points / 10;

    return {
        spreadInPoints: points,
        spreadInPointsDisplayValue: `${points} ${t("points")}`,
        spreadInPips: pips,
        spreadInPipsDisplayValue: isNaN(pips) ? `0 ${t("pips")}` : `${pips.toFixed(1)} ${t("pips")}`,
    };
}